module.exports = __webpack_public_path__ + "static/img/img-contact.0c323f3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/img-contact.svg
// module id = 503
// module chunks = 1